var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Cadastro desatualizado" },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("el-row", { staticClass: "margin-bottom" }, [
            _c("b", [_vm._v("Atenção:")]),
            _c("span", [
              _vm._v(
                "  Este .sicarf foi gerado em uma versão antiga do SiCARF-OFF (Módulo de cadastros)! Por favor, atualize para a versão mais recente, gere um novo .sicarf e tente enviar novamente!"
              )
            ])
          ]),
          _c("el-row", { staticClass: "margin-bottom" }, [
            _c("span", [_vm._v("Para atualizar, siga os seguintes passos:")])
          ]),
          _c(
            "el-row",
            { staticClass: "margin-left" },
            [
              _c("el-row", { staticClass: "margin-bottom5" }, [
                _c("span", [
                  _vm._v(
                    '1) No site, acesse a aba "Como Baixar" e baixe novamente o módulo de cadastros.'
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom5" }, [
                _c("span", [
                  _vm._v(
                    "2) Execute o instalador para atualizar o sistema. Não se preocupe, você não perderá os cadastros já realizados!"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom5" }, [
                _c("span", [
                  _vm._v(
                    "3) Após atualizar o módulo de cadastros, você deverá finalizar novamente os cadastros e exportá-los."
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom5" }, [
                _c("span", [
                  _vm._v(
                    '4) Com o .sicarf gerado pela nova versão, você retornará na aba "Como enviar" do site para realizar o envio novamente.'
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.$emit("closeModal")
                  }
                }
              },
              [
                _c("span", [
                  _c("i", { staticClass: "fa fa-check" }),
                  _c("span", [_vm._v("  Confirmar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c1a0804", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c1a0804","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppModalErroVersao.vue
// module id = null
// module chunks = 